import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-vote',
  templateUrl: './vote.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoteComponent {
  @Input() voteCount: number = 0;
  @Input() isVoted: boolean = false;

  @Input() title?: string;
  @Input() text?: string;
  @Input() likeButtonLabel?: string;

  @Input() resultTitle?: string;
  @Input() resultText?: string;

  @Output() vote = new EventEmitter<void>();

  get count() {
    // fix cache on your own vote
    return this.voteCount ? this.voteCount : this.isVoted ? 1 : 0;
  }
}
